/**
 * Shared helpers to resolve warehouse inventory list id from Shopper Stores (IM-002).
 */

/**
 * Extract inventory list id from Shopper Stores record (BM: c_inventoryListId).
 *
 * @param {Object|null|undefined} store
 * @returns {string|null}
 */
export function pickInventoryListIdFromStore(store) {
  if (!store) {
    return null;
  }

  return store.c_inventoryListId ?? store.c_inventoryListID ?? store.inventoryListId ?? null;
}
